import { SnackbarProvider as NotistackProvider } from 'notistack';
import { PropsWithChildren } from 'react';

export function SnackbarProvider(props: PropsWithChildren) {
  return (
    <NotistackProvider
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      {props.children}
    </NotistackProvider>
  );
}
